import Config from "services/config/config";
import callWebService, {
    callTypes
} from "services/utils/networks/network";
import {
    CREATE_PROJECT,
    SEARCH_PROJECT,
    UPDATE_PROJECT,
    PROJECT_PRICING,
    INFRA_ID_FOR_VALET,
    VALET_MONTHLY_DATA,
    CALCULATE_SALARY,
    DAILY_SALARY_DISTRIBUTION,
    MARK_HOLIDAYS_FOR_VALET,
    UPDATE_SALARY_STATUS,
    ALL_RAISED_TICKETS,
    RESPOND_VALET_OPS,
    STATUS_UPDATE_BY_VALET_HEAD,
    PENALTY_LISTING,
    GET_EVENT_SALARY,
    APPROVE_EVENT_SALARY,
    MASTER_SALARY_PENALTY, MASTER_SALARY_PENALTY_LIST, SALARY_BY_PHONE_NO, ALL_ABSCOND_DRIVERS, RELEASE_ABSCOND_DRIVERS, APPROVE_ABSCOND_DRIVERS, ADVANCE_SALARY_LIST, ADVANCE_SALARY_CALCULATE, ADVANCE_SALARY_UPDATE
} from "./type";

export const createProject = (requestParams) => async (dispatch) => {

    try {
        const res = await callWebService(
            callTypes.post,
            {
                'zone_selection_type': requestParams.zone_selection_type,
                'allow_get_my_car': requestParams.allow_get_my_car,
                'allow_arrived_notification': requestParams.allow_arrived_notification,
                'allow_delivered_notification': requestParams.allow_delivered_notification,
                'allow_parked_notification': requestParams.allow_parked_notification,
                'pre_payment': requestParams.pre_payment,
                'project_name': requestParams.project_name,
                'address': requestParams.address,
                'city': requestParams.city,
                'latitude': requestParams.latitude,
                'longitude': requestParams.longitude,
                'project_id': parseInt(requestParams.project_id),
                'price': requestParams.price,
                'gmc': requestParams.gmc,
                'pmc': requestParams.pmc,
                'sunday': requestParams.sunday,
                'monday': requestParams.monday,
                'tues': requestParams.tues,
                'wed': requestParams.wed,
                'thur': requestParams.thur,
                'fri': requestParams.fri,
                'sat': requestParams.sat,
                'base_hours': requestParams.base_hours,
                'image_url': requestParams.image_url,
                'is_saas': requestParams.is_saas,
                'is_punched': requestParams.is_punched,
                'is_progressive': requestParams.is_progressive,
                'is_platform_fee_allowed': requestParams.is_platform_fee_allowed,
                'platform_fee': parseFloat(requestParams.platform_fee),
                'is_image_skippable_site': requestParams.is_image_skippable_site,
                'eta':parseInt(requestParams.eta),
                'project_radius': requestParams.project_radius,
                'holiday': requestParams.holiday,
                'flow_type': requestParams.flow_type,
                'show_pms_entered_vehicle': requestParams.show_pms_entered_vehicle,
                'is_vrn_validation_required': requestParams.is_vrn_validation_required,
                'allow_delivery_otp': requestParams.allow_delivery_otp,
                'is_insurance_allowed': requestParams.is_insurance_allowed,
                'allow_prebook_otp': requestParams.allow_prebook_otp,
                'is_prebooking_allowed': requestParams.is_prebooking_allowed,
                'operational_start_time': requestParams.operational_start_time,
                'operational_end_time': requestParams.operational_end_time,
                'pass_type_applicable': requestParams.pass_type_applicable,
                'duty_mode': requestParams.duty_mode,
                'business_type': requestParams.business_type,
                'operational_days': requestParams.operational_days,
                'gmc_mandatory_count': requestParams.gmc_mandatory_count

            },
            `${Config.valet.project}`
        );

        if (res) {
            const { data } = res;
            dispatch({
                type: CREATE_PROJECT,
                payload: data,
            });
            return true;
        }
    }
    catch {
        dispatch({
            type: CREATE_PROJECT,
            payload: null,
        });
        return true;
    }
}

export const searchProject = (projectId, editProjectButtonToggle) => async (dispatch) => {
    try {
        let edit = editProjectButtonToggle ? 1 : 0;
        const res = await callWebService(
            callTypes.get,
            {},
            `${Config.valet.searchProject}?project_id=`+parseInt(projectId)+'&is_editable='+edit
        );

        if (res) {
            const { data } = res;
            dispatch({
                type: SEARCH_PROJECT,
                payload: data,
            });
            return true;
        }
    }
    catch {
        dispatch({
            type: SEARCH_PROJECT,
            payload: null,
        });
        return true;
    }
}


export const updateProject = (requestParams) => async (dispatch) => {

    try {
        const res = await callWebService(
            callTypes.post,
            {
                'zone_selection_type': requestParams.zone_selection_type,
                'allow_get_my_car': requestParams.allow_get_my_car,
                'allow_arrived_notification': requestParams.allow_arrived_notification,
                'allow_delivered_notification': requestParams.allow_delivered_notification,
                'allow_parked_notification': requestParams.allow_parked_notification,
                'pre_payment': requestParams.pre_payment,
                'project_name': requestParams.project_name,
                'address': requestParams.address,
                'city': requestParams.city,
                'latitude': requestParams.latitude,
                'longitude': requestParams.longitude,
                'project_id': parseInt(requestParams.project_id),
                'price': requestParams.price,
                'gmc': requestParams.gmc,
                'pmc': requestParams.pmc,
                'sunday': requestParams.sunday,
                'monday': requestParams.monday,
                'tues': requestParams.tues,
                'wed': requestParams.wed,
                'thur': requestParams.thur,
                'fri': requestParams.fri,
                'sat': requestParams.sat,
                'base_hours': requestParams.base_hours,
                'image_url': requestParams.image_url,
                'is_saas': requestParams.is_saas,
                'is_progressive': requestParams.is_progressive,
                'is_platform_fee_allowed': requestParams.is_platform_fee_allowed,
                'platform_fee': parseFloat(requestParams.platform_fee),
                'is_image_skippable_site': requestParams.is_image_skippable_site,
                'eta':parseInt(requestParams.eta),
                'holiday': requestParams.holiday,
                'flow_type': requestParams.flow_type,
                'show_pms_entered_vehicle': requestParams.show_pms_entered_vehicle,
                'is_vrn_validation_required': requestParams.is_vrn_validation_required,
                'allow_delivery_otp': requestParams.allow_delivery_otp,
                'is_insurance_allowed': requestParams.is_insurance_allowed,
                'allow_prebook_otp': requestParams.allow_prebook_otp,
                'is_prebooking_allowed': requestParams.is_prebooking_allowed,
                'operational_start_time': requestParams.operational_start_time,
                'operational_end_time': requestParams.operational_end_time,
                'pass_type_applicable': requestParams.pass_type_applicable,
                'business_type': requestParams.business_type,
                'operational_days': requestParams.operational_days,
                'gmc_mandatory_count': requestParams.gmc_mandatory_count,
                'project_type': requestParams.project_type,
                'active': requestParams.active,
            },
            `${Config.valet.updateProject}`
        );

        if (res) {
            const { data } = res;
            dispatch({
                type: UPDATE_PROJECT,
                payload: data,
            });
            return true;
        }
    }
    catch {
        dispatch({
            type: UPDATE_PROJECT,
            payload: null,
        });
        return true;
    }
}


export const getPriceProject = (projectId, editProjectButtonToggle) => async (dispatch) => {
    try {
        let edit = editProjectButtonToggle ? 1 : 0;
        const res = await callWebService(
            callTypes.get,
            {},
            `${Config.valet.projectPricing}?project_id=`+projectId
        );

        if (res) {
            const { data } = res;
            dispatch({
                type: PROJECT_PRICING,
                payload: data,
            });
            return true;
        }
    }
    catch {
        dispatch({
            type: PROJECT_PRICING,
            payload: null,
        });
        return true;
    }
}

export const getInfraIDForValet = () => async (dispatch) => {
    try {
        const res = await callWebService(
            callTypes.get,
            {},
            `${Config.valet.getInfraId}`
        );

        if (res) {
            const { data } = res;
            dispatch({
                type: INFRA_ID_FOR_VALET,
                payload: data,
            });
            return true;
        }
    }
    catch {
        dispatch({
            type: INFRA_ID_FOR_VALET,
            payload: null,
        });
        return true;
    }
}


export const getMonthlyDataForValet = (page=1, phone=null, filter = null, status = null, month=null, year=null) => async (dispatch) => {
    let url = `${Config.valet.getMonthlyData}?page=${page}`
    if(filter !== null){
        if(filter.phone_number){
            url+= `&phone_number=${filter.phone_number}`
        }
        if(filter.month){
            url+= `&month=${filter.month}`
        }
        if(filter.year){
            url+= `&year=${filter.year}`
        }
        if(filter.status){
            url+= `&status=${filter.status}`
        }
    }
    if(phone!== null && status !== null){
        url+= `&phone=${phone}&status=${status}`
    }

    if(month!== null && year !== null){
        url+= `&month=${month}&year=${year}`
    }
    const res = await callWebService(
        callTypes.get,
        '',
        url
    );
    if (res) {
      const {data} = res;
      dispatch({type: VALET_MONTHLY_DATA, payload: data});
      return data.response.data;
    }
  };

export const calculateSalaryForValet = (data) => async (dispatch) => {
    try {
        const res = await callWebService(
            callTypes.post,
            data,
            `${Config.valet.calculateValetSalary}`
        );

        if (res) {
            const { data } = res;
            dispatch({
                type: CALCULATE_SALARY,
                payload: data,
            });
            return data.response;
        }
    }
    catch {
        return false;
    }
}

export const dailyValetSalaryDistribution = (data) => async (dispatch) => {
    try {
        const res = await callWebService(
            callTypes.post,
            data,
            `${Config.valet.dailySalaryDistribution}`
        );

        if (res) {
            const { data } = res;
            dispatch({
                type: DAILY_SALARY_DISTRIBUTION,
                payload: data,
            });
            return true;
        }
    }
    catch {
        return false;
    }
}

export const markHolidaysForValet = (data) => async (dispatch) => {
    try {
        const res = await callWebService(
            callTypes.post,
            data,
            `${Config.valet.markHolidays}`
        );

        if (res) {
            const { data } = res;
            dispatch({
                type: MARK_HOLIDAYS_FOR_VALET,
                payload: data,
            });
            return true;
        }
    }
    catch {
        dispatch({
            payload: null,
        });
        return true;
    }
}

export const updateSalaryStatusForValet = (data) => async (dispatch) => {
    try {
        const res = await callWebService(
            callTypes.post,
            data,
            `${Config.valet.updateSalaryStatus}`
        );

        if (res) {
            const { data } = res;
            dispatch({
                type: UPDATE_SALARY_STATUS,
                payload: data,
            });
            return data.response;
        }
    }
    catch {
        return false;
    }
}


export const getAllValetRaisedTickets = (page=1,filter, messageId) => async (dispatch) => {
    let url = Config.valet.getAllRaisedTicketsForValet
    console.log("FILTER",filter)
    url += `?page=${page}`

    if(filter?.status!== null && filter?.status!== undefined){
        url+= `&status=${filter?.status}`
    }
    if(filter?.role_id!== null && filter?.role_id!== undefined){
        url+= `&role_id=${filter?.role_id}`
    }
    if(filter?.phone_number!== null && filter?.phone_number!== undefined){
        url+= `&phone_number=${filter?.phone_number}`
    }

    if(messageId!== null){
        url+= `&message_id=${messageId}`
    }
    const res = await callWebService(
        callTypes.get,
        '',
        url
    );
    if (res) {
      const {data} = res;
      dispatch({type: ALL_RAISED_TICKETS, payload: data});
      return data.response.data;
    }
  };

  export const getValetOpsRespond = (data) => async (dispatch) => {
    try {
        const res = await callWebService(
            callTypes.post,
            data,
            `${Config.valet.respondedByValetOps}`
        );

        if (res) {
            const { data } = res;
            dispatch({
                type: RESPOND_VALET_OPS,
                payload: data,
            });
            return data.response;
        }
    }
    catch {
        return false;
    }
}

export const updateStatusValetHead = (data) => async (dispatch) => {
    try {
        const res = await callWebService(
            callTypes.post,
            data,
            `${Config.valet.statusUpdateByValetHead}`
        );

        if (res) {
            const { data } = res;
            dispatch({
                type: STATUS_UPDATE_BY_VALET_HEAD,
                payload: data,
            });
            return data.response;
        }
    }
    catch {
        return false;
    }
}

// export const valetPenaltyListing = (user_id,from_date,to_date,project_id,page=1) => async (dispatch) => {
//     try {
        
//           let  url = `${Config.valet.getPenaltyList}?user_id=${user_id}&from_date=${from_date}&to_date=${to_date}&project_id=${project_id}`;

//         const res = await callWebService(
//             callTypes.get,
//             {},
//             url
//         );

//         if (res) {
//             const { data } = res;
//             console.log("DATA",data?.response?.data)
//             dispatch({
//                 type: PENALTY_LISTING,
//                 payload: data?.response?.data,
//             });
//             return true;
//         }
//     }
//     catch {
//         dispatch({
//             type: PENALTY_LISTING,
//             payload: null,
//         });
//         return true;
//     }
// }

export const valetPenaltyListing = (user_id,from_date,to_date,project_id,page=1) => async (dispatch) => {
    let  url = `${Config.valet.getPenaltyList}?user_id=${user_id}&from_date=${from_date}&to_date=${to_date}`;
    const res = await callWebService(
      callTypes.get,
      "",
      url
    );
    if (res) {
      const { data } = res;
      console.log("DATA",data.response.data)
        dispatch({ 
            type: PENALTY_LISTING, 
            payload: data?.response?.data
        });
      return data?.response?.data;
    }
}
const buildQueryParams = (params) => {
    return Object.entries(params)
        .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
        .join("&");
};
export const getValetEventSalary = (page=1, filters=null) => async (dispatch) => {
    try {
        var url = `${Config.valet.getEventSalary}?page=${page}`;
        if(filters!=null){
            const queryString = buildQueryParams(filters);
            url = `${Config.valet.getEventSalary}?page=${page}&${queryString}`;
        }
        const res = await callWebService(
            callTypes.get,
            '',
            url
        );
        if (res) {
            const { data } = res;
            dispatch({
                type: GET_EVENT_SALARY,
                payload: data?.response?.data,
            });
            return data?.response?.data;
        }
    }
    catch {
        return false;
    }
}
export const approveValetEventSalary = (data) => async (dispatch) => {
    try {
        const res = await callWebService(
            callTypes.patch,
            data,
            `${Config.valet.approveEventSalary}`
        );

        if (res) {
            const { data } = res;
            dispatch({
                type: APPROVE_EVENT_SALARY,
                payload: data,
            });
            return data.response;
        }
    }
    catch {
        return false;
    }
}

export const masterSalaryPenaltyRequest = (data) => async (dispatch) => {
    try {
        const res = await callWebService(
            callTypes.post,
            data,
            `${Config.valet.masterSalaryPenalty}`
        );

        if (res) {
            const { data } = res;
            dispatch({
                type: MASTER_SALARY_PENALTY,
                payload: data,
            });
            return data.response;
        }
    }
    catch {
        return false;
    }
}

export const masterSalaryPenaltyListRequest = (salaryId) => async (dispatch) => {
    try {
        const res = await callWebService(
            callTypes.get,
            '',
            `${Config.valet.masterSalaryPenaltyLis}?salary_id=${salaryId}`
        );

        if (res) {
            const { data } = res;
            dispatch({
                type: MASTER_SALARY_PENALTY_LIST,
                payload: data,
            });
            return data.response;
        }
    }
    catch {
        return false;
    }
}

export const salaryByPhone = (phoneNo) => async (dispatch) => {
    try {
        const res = await callWebService(
            callTypes.get,
            '',
            `${Config.valet.salaryByPhoneNo}?phone_no=${phoneNo}`
        );

        if (res) {
            const { data } = res;
            dispatch({
                type: SALARY_BY_PHONE_NO,
                payload: data,
            });
            return data.response;
        }
    }
    catch {
        return false;
    }
}

export const getAllAbscondedDrivers = (page=1, show_absconded=null, status=null) => async (dispatch) => {
    let url = `${Config.valet.getMonthlyData}?page=${page}`
    if(status!=null){
        url+= `&absconding_status=${status}`
    }
    if(show_absconded!== null){
        url+= `&show_absconded=${show_absconded}`
    }
    const res = await callWebService(
        callTypes.get,
        '',
        url
    );
    if (res) {
      const {data} = res;
      dispatch({type: ALL_ABSCOND_DRIVERS, payload: data});
      return data.response.data;
    }
  };

  export const releaseAbscondedDrivers = (data) => async (dispatch) => {
    try {
        const res = await callWebService(
            callTypes.post,
            data,
            `${Config.valet.releaseSalary}`
        );

        if (res) {
            const { data } = res;
            dispatch({
                type: RELEASE_ABSCOND_DRIVERS,
                payload: data,
            });
            return res;
        }
    }
    catch {
        return false;
    }
}

export const approveAbscondedDrivers = (data) => async (dispatch) => {
    try {
        const res = await callWebService(
            callTypes.post,
            data,
            `${Config.valet.updateSalaryStatus}`
        );

        if (res) {
            const { data } = res;
            dispatch({
                type: APPROVE_ABSCOND_DRIVERS,
                payload: data,
            });
            return res;
        }
    }
    catch {
        return false;
    }
}

export const advanceSalaryListingRequest = (page=1) => async (dispatch) => {
    let url = `${Config.valet.advanceSalaryList}?page=${page}`
    const res = await callWebService(
        callTypes.get,
        '',
        url
    );
    if (res) {
      const {data} = res;
      dispatch({type: ADVANCE_SALARY_LIST, payload: data});
      return data;
    }
};

export const advanceSalaryCalculateRequest = (data) => async (dispatch) => {
    try {
        const res = await callWebService(
            callTypes.post,
            data,
            `${Config.valet.advanceSalaryCalculate}`
        );

        if (res) {
            const { data } = res;
            dispatch({
                type: ADVANCE_SALARY_CALCULATE,
                payload: data,
            });
            return res?.data;
        }
    }
    catch {
        return false;
    }
}

export const advanceSalaryUpdateRequest = (data) => async (dispatch) => {
    try {
        const res = await callWebService(
            callTypes.post,
            data,
            `${Config.valet.advanceSalaryUpdate}`
        );

        if (res) {
            const { data } = res;
            dispatch({
                type: ADVANCE_SALARY_UPDATE,
                payload: data,
            });
            return res?.data;
        }
    }
    catch {
        return false;
    }
}
